var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from 'react';
import colors from '../colors';
import { sizeMap } from './common';
export var SlidersVertical = forwardRef(function (props, ref) {
    var _a = props.color, color = _a === void 0 ? colors.grey[900] : _a, _b = props.variant, variant = _b === void 0 ? 'default' : _b, _c = props.title, title = _c === void 0 ? '' : _c;
    var size = sizeMap[variant];
    return (_jsxs("svg", __assign({ width: size, height: size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: ref }, props, { children: [_jsx("title", { children: title }), _jsx("path", { d: "M7.875 13.875L7.875 3.75M7.875 13.875C6.83947 13.875 6 14.7145 6 15.75C6 16.7855 6.83947 17.625 7.875 17.625M7.875 13.875C8.91053 13.875 9.75 14.7145 9.75 15.75C9.75 16.7855 8.91053 17.625 7.875 17.625M7.875 20.25L7.875 17.625M16.125 7.875V3.75M16.125 7.875C15.0895 7.875 14.25 8.71447 14.25 9.75C14.25 10.7855 15.0895 11.625 16.125 11.625M16.125 7.875C17.1605 7.875 18 8.71447 18 9.75C18 10.7855 17.1605 11.625 16.125 11.625M16.125 20.25V11.625", stroke: color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" })] })));
});
